import { useContext, useMemo } from 'react'
import * as React from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import styled from 'styled-components'
import { rem } from 'polished'

import HeadData from 'components/Common/HeadData'
import Heading from 'LuxKit/Typography/Heading'
import ImageHero from 'components/Common/ImageHero'
import Group from 'components/utils/Group'
import Search from 'home/components/Search/Search'
import GeoContext from 'contexts/geoContext'
import { getHomeOfferListParams } from 'home/helpers'
import OfferCardCarouselSection from 'components/Common/OfferCardCarousel/OfferCardCarouselSection'

const HeroContainer = styled(ImageHero)`
  max-height: ${rem(400)};
`

function Error404PageWithOffers() {
  const intl = useIntl()
  const { currentRegionCode, geoStateName } = useContext(GeoContext)

  const filters = useMemo(() => getHomeOfferListParams({
    region: currentRegionCode,
    subregion: geoStateName,
  }), [currentRegionCode, geoStateName])

  const pageTitle = intl.formatMessage({
    id: '8lH0KxwYRo-dnXxIEwLy',
    defaultMessage: 'Page Not Found',
  })

  const pageDescription = intl.formatMessage({
    id: '-Q8xcZJ48yR28UfrDxHW',
    defaultMessage: '404 - page not found',
  })

  const imageAlt = intl.formatMessage({
    id: '-EpkFEnbeaIKrsHOxSTA',
    defaultMessage: 'Oops! We can’t find that page',
  })

  const mainHeading = intl.formatMessage({
    id: 'vrcjeXgF7HaM8V3L-4bm',
    defaultMessage: 'Oops! We can’t find that page.',
  })

  const subHeading = intl.formatMessage({
    id: '8fvP0a6Cky6Xbk6viRYY',
    defaultMessage: 'Let’s get you back on your journey.',
  })

  return (
    <div className="Error404Page T-Error404Page">
      <HeadData
        title={pageTitle}
        description={pageDescription}
      />
      <HeroContainer
        alt={imageAlt}
        aria-hidden="true"
        brightness={-40}
        gravity="auto"
        fit="center"
        quality="good"
        mobileAspectRatio="4:3"
        desktopAspectRatio="3:1"
        largeDesktopAspectRatio="4:1"
        id="hc71fr4ynk0ljlqnw399"
      >
        <Group data-testid="404-error-page" direction="vertical" horizontalAlign="center" gap={8}>
          <Heading variant="heading1" align="center" colour="dark-contrast">{mainHeading}</Heading>
          <Heading variant="heading4" align="center" colour="dark-contrast">{subHeading}</Heading>
        </Group>
      </HeroContainer>
      <Search />
      <OfferCardCarouselSection
        title={<FormattedMessage
          id="ea6wxjp5Sa59qnl35Uxz"
          defaultMessage="Explore our <i>top offers</i>"
          
          values={{
            i: (chunks: React.ReactNode) => <i>{chunks}</i>,
          }}
        />}
        filters={filters}
      />
    </div>
  )
}

export default React.memo(Error404PageWithOffers)
